import { createFileRoute } from "@tanstack/react-router";

import { Navigate } from "@/lib/router-compat";
export const Route = createFileRoute("/san-francisco-dinners")({
  component: () => <Navigate to="/cities/san-francisco" replace />,
});
